import { closest, removeNode, addClass, removeClass, toggleClass } from '@utils/domUtils';

export default class CustomCandidateSelector {
  static selectorString() {
    return '.CustomCandidateSelector';
  }

  render(node, props) {
    this.form = node.querySelector('form');

    [...node.querySelectorAll('.candidate .button-toggle-selection')].forEach(element => {
      element.candidate = closest(element, '.candidate');
      element.addEventListener('click', this.selectCandidate.bind(this));
    });
  }

  selectCandidate(event) {
    event.preventDefault();

    const candidate = event.currentTarget.candidate;
    toggleClass(candidate, 'selected');
    this.updateSelectionStatus();
  }

  updateSelectionStatus() {
    const candidateIds = [...this.node.querySelectorAll('.candidate.selected')].map(element =>
      element.getAttribute('data-id'),
    );

    [...this.form.querySelectorAll('[name="candidates[]"]')].forEach(element => {
      removeNode(element);
    });

    candidateIds.forEach(id => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'candidates[]';
      input.value = id;
      this.form.appendChild(input);
    });

    if (candidateIds.length > 0) {
      addClass(this.node, 'is-valid');
    } else {
      removeClass(this.node, 'is-valid');
    }
  }
}
